import { Label, Stack } from "@fluentui/react";
import { FilePickButton } from "../../pages/admin/components";
import { FileIcon } from "./FileIcon";
import { historyGetCreateFile } from "../../api";
import { downloadBlob } from "../../api/admin/api_admin";
import { useState } from "react";

export interface FileInfo {
    name: string;
    // blobFileNameが存在する場合はクリックでダウンロード、存在しない場合は新規アプロードファイルとみなす
    blobFileName?: string;
    id: string;
}

interface FilePickerProps {
    label?: string;
    listedFiles: FileInfo[];
    onFilePicked: (files: FileList | null) => void;
    onRemoveFile: (fileId: string) => void;
}

export const FilePicker = (props: FilePickerProps) => {
    const {label, listedFiles, onFilePicked, onRemoveFile} = props;
    const [loadingIds, setLoadingIds] = useState<Set<string>>(new Set())

    const downloadBlobFile = async (fileId: string) => {
        try{
            setLoadingIds((v) => {
                v.add(fileId)
                return new Set(v)
            })
            const fileInfo = listedFiles.find((f) => f.id == fileId);
            if (fileInfo === undefined || fileInfo.blobFileName === undefined) return;
            const fileBase64 = await historyGetCreateFile(fileInfo.blobFileName);
            const byteCharacters = atob(fileBase64);
            const byteNumbers = Array.from(byteCharacters).map((char) =>
                char.charCodeAt(0),
            );
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);
            downloadBlob(blob, fileInfo.name);
        }
        finally {
            setLoadingIds((v) => {
                v.delete(fileId)
                return new Set(v)
            })
        }

    }

    return <Stack tokens={{childrenGap: "8px"}} style={{backgroundColor: "#e8e8e8", width: "100%", minHeight: "100px", borderRadius: "10px", padding: "10px"}}>
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            {<Label>{label ?? ""}</Label>}
            <FilePickButton onFileChange={onFilePicked} />
        </Stack>
        <Stack horizontal wrap tokens={{childrenGap: "8px"}}>
        {
            listedFiles.map((f) => <FileIcon 
                key={f.id}
                isLoading={loadingIds.has(f.id)}
                name={f.name} 
                backgroundColor={f.blobFileName ? "#ffffff" : "#FFFFDD"}
                onRemoveFile={() => onRemoveFile(f.id)} 
                onClick={f.blobFileName ? async () => { await downloadBlobFile(f.id) } : undefined} />)
        }
        </Stack>
    </Stack>
}